import { render, staticRenderFns } from "./ShipmentMain.vue?vue&type=template&id=d8d49ab0&scoped=true"
import script from "./ShipmentMain.vue?vue&type=script&lang=js"
export * from "./ShipmentMain.vue?vue&type=script&lang=js"
import style0 from "./ShipmentMain.vue?vue&type=style&index=0&id=d8d49ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d49ab0",
  null
  
)

export default component.exports